import axios from 'axios';

const url="https://dream11-app-akshaya.herokuapp.com/api";

export default axios.create({
    baseURL: url
  });
